export default __webpack_public_path__ + "static/media/devX_ai.09dffae5.svg";